import { motion } from "framer-motion";
import { AUDIENCES } from "../../data/content";
import { MaskedLineInView } from "../MaskedLine";

const GROUNDS = ["ground-highlighter", "ground-lab", "ground-margin", "ground-paper"];

export default function AudienceSection() {
  return (
    <section data-testid="audience-section" className="ground-paper sec-pad">
      <div className="wrap">
        <div className="max-w-[880px] mb-16">
          <span className="series-stamp"><span>The Rooms</span></span>
          <h2 className="h-section mt-8">
            <MaskedLineInView>We are not</MaskedLineInView>
            <MaskedLineInView delay={0.08}>for everyone.</MaskedLineInView>
            <MaskedLineInView delay={0.16}><span className="claim">Here is who.</span></MaskedLineInView>
          </h2>
        </div>

        <div className="border-t-[1.5px] border-[color:var(--ink)] grid grid-cols-1 md:grid-cols-2">
          {AUDIENCES.map((a, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.8, delay: (i % 2) * 0.08, ease: [0.22, 1, 0.36, 1] }}
              data-testid={`audience-card-${i}`}
              className={`${GROUNDS[i]} p-10 md:p-14 border-b-[1.5px] border-[color:var(--ink)] ${i % 2 === 1 ? "md:border-l-[1.5px]" : ""}`}
            >
              <span className="stamp" style={{ fontSize: 11 }}>Cohort · 0{i + 1}</span>
              <h3 className="h-tile mt-6" style={{ fontSize: "clamp(24px, 2.4vw, 32px)" }}>{a.title}</h3>
              <p className="font-aside mt-6 text-[19px] leading-[1.55] max-w-[520px]">{a.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
